import * as React from 'react';
import { SVGProps } from 'react';

const SvgAccount = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4a4.003 4.003 0 0 1 4 4 4 4 0 1 1-4-4zm0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4z" />
  </svg>
);

export default SvgAccount;
